import { useQuery } from '@tanstack/react-query';
import clientsService from '../services/clientsService';

export const CLIENTS_KEY = ['attorney', 'clients'];

/**
 * Hook to fetch all clients
 */
export function useClients(options = {}) {
  return useQuery({
    queryKey: [...CLIENTS_KEY, options],
    queryFn: () => clientsService.getClients(options),
    staleTime: 1000 * 60 * 5, // 5 minutes
    refetchOnWindowFocus: true
  });
}

/**
 * Hook to fetch a single client
 */
export function useClient(clientId) {
  return useQuery({
    queryKey: [...CLIENTS_KEY, clientId],
    queryFn: () => clientsService.getClient(clientId),
    enabled: !!clientId,
    staleTime: 1000 * 60 * 5
  });
}

export default {
  useClients,
  useClient
};
